var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "0.37in",
    height: "0.37in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    strokeWidth: "1px",
    stroke: "rgb(221, 55, 62)",
    fillOpacity: 0,
    fill: "rgb(221, 55, 62)",
    d: "M17.500,3.500 C25.232,3.500 31.500,9.768 31.500,17.500 C31.500,25.232 25.232,31.500 17.500,31.500 C9.768,31.500 3.500,25.232 3.500,17.500 C3.500,9.768 9.768,3.500 17.500,3.500 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(221, 55, 62)",
    d: "M24.500,19.500 C23.395,19.500 22.500,18.605 22.500,17.500 C22.500,16.395 23.395,15.500 24.500,15.500 C25.605,15.500 26.500,16.395 26.500,17.500 C26.500,18.605 25.605,19.500 24.500,19.500 ZM17.500,19.500 C16.395,19.500 15.500,18.605 15.500,17.500 C15.500,16.395 16.395,15.500 17.500,15.500 C18.605,15.500 19.500,16.395 19.500,17.500 C19.500,18.605 18.605,19.500 17.500,19.500 ZM10.500,19.500 C9.395,19.500 8.500,18.605 8.500,17.500 C8.500,16.395 9.395,15.500 10.500,15.500 C11.605,15.500 12.500,16.395 12.500,17.500 C12.500,18.605 11.605,19.500 10.500,19.500 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardBtn);
export default __webpack_public_path__ + "static/media/dashboardBtn.81a85bc5d8ea75e6e596da6f1016e90a.svg";
export { ForwardRef as ReactComponent };